module.exports = __webpack_public_path__ + "img/dc1e20b9803721dfd8f54773f092c161.71f4a0ee.jpg";